import { render, staticRenderFns } from "./codeadd.vue?vue&type=template&id=680a8092&scoped=true"
import script from "./codeadd.vue?vue&type=script&lang=js"
export * from "./codeadd.vue?vue&type=script&lang=js"
import style0 from "./codeadd.vue?vue&type=style&index=0&id=680a8092&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680a8092",
  null
  
)

export default component.exports